$(document).ready(function(){
  var wk_error_limit ='<p style="color:red;font-size:12px;" class="wk-cart-error-product-msg">This is a pre-loved item, only 1 is available</p>';
  var wk_error_cart_p_limit_msg ='<p style="color:red;font-size:12px;" class="wk-cart-error-msg">Something Went Wrong</p>';
  console.log('wk_cart_validate_customise.js');
  $("body").on("click", ".wk_cart_validated_prod_limit a", function(e) {
    var parent_e =$(this).parent('.wk_cart_validated_prod_limit');
    var line_item_id =parent_e.data('line_item_id');
    if(($(this).data('action_type')=='plus')&&($(this).data('quantity')>1)){
	  e.preventDefault();
      $('.wk_cart_p_'+line_item_id).each(function() {
        var wk_error_limit_append = $(this).next('.wk-cart-error-product-msg')
        if(wk_error_limit_append.length==0){
          $(this).after(wk_error_limit);          
        }
      });
      return false;
    }
  });
  $("body").on("click",'a[name="checkout"],button[name="checkout"]', function(e) {
    e.preventDefault();
    var cart_limit_exceed = false;
    // check checkout form is vaild
    $('.wk_cart_validated_prod_limit').each(function() {
      if($(this).find('input').val()>1){
        cart_limit_exceed = true;
        if(cart_limit_exceed){
          return false;
        }
      }
    });
    if(cart_limit_exceed){
      if($(this).prev('.wk-cart-error-msg').length==0){
		$(this).before(wk_error_cart_p_limit_msg);        
      }
      return false;
    }
  });  
});